import React from 'react';
import Highlight from 'react-scale/components/elements/highlight';
import TaskResponseVideo from '../tasks/TaskResponseVideo';

export const instruction =
  'Annotate all the vehicles, pedestrians and traffic lights in the video.';

export const responseCode = `{
  "annotations": {
    "url": "https://scaleapi-results.s3.us-west-1.amazonaws.com/4b7c4bd0-b1ee-11e8-b472-b39f604468d8",
  },
}`;

export const code = `client.createVideoannotationTask({
    callback_url: 'http://www.example.com/callback',
    instruction: '${instruction}',
    attachment_type: 'video',
    attachment: 'http://example.com/video.mp4',
    objects_to_annotate: ['person'],
  },
  (err, task) => {
    // do something with task
  }
);`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);
const annotatedMuxPlaybackID = 'RxE00SGirJH1b8gWgggBUvcJXqoFKUUmK';
const originalMuxPlaybackID = 'bseaZdPe3POSjNStE02Kl02vACu2dVZKVP';

const component = ({ refAsync }) => (
  <TaskResponseVideo
    annotatedMuxPlaybackID={annotatedMuxPlaybackID}
    originalMuxPlaybackID={originalMuxPlaybackID}
    ref={refAsync}
  />
);

export const example = { component };

export const result = null;
